import { FRENCH_SUBDIVISIONS, subdivisionLabel } from '@erp/shared';

export const subdivisionOptions = FRENCH_SUBDIVISIONS.map((entry) => ({
  id: entry.code,
  label: subdivisionLabel({ subdivisionCode: entry.code, subdivisionName: entry.name }),
}));
